<template>
  <div class="table" style="padding: 10px">
    <a-row type="flex" align="middle" justify="space-between" style="margin-bottom: 10px">
      <h4>
        <a-space>
          补充料
          <span style="margin-left: 10px">重量:
            <span style="font-weight: bold">{{ weightNum.toFixed(3) }}</span>
            KG</span>
          <span style="margin-left: 10px">价格:
            <span style="font-weight: bold">{{
              !detail.price
              ? "0.000"
              : Number(
              ((detail.price || 0) * (weightNum || 1)) /
              (detail.totalWeight || 1)
              ).toFixed(3)
              }}</span>元（{{
            !detail.price ? "0.000" : detail.price.toFixed(3)
            }}元/吨）</span>
        </a-space>
      </h4>
      <!-- <a-space> -->
      <div>
        <!-- <a-tag v-if="selectedRowKeys.length" color="blue">已选择{{selectedRowKeys.length}}项</a-tag>
        <a-button size="small" type="primary" @click="toggleRawVisible" style="font-size:12px">添加</a-button>
        <a-button :disabled="removeDisable" @click="removeRaw" size="small" type="danger" ghost="">移出</a-button>
        <a-select v-model="rawsType" style="width: 120px" @change="rawsChange">
          <a-select-option value="all">所有原料</a-select-option>
          <a-select-option value="1">组分原料</a-select-option>
          <a-select-option value="2">拒绝原料</a-select-option>
        </a-select>
        <a-select v-model="columnsArr" class="multipleStyle" style="width: 200px;" mode="multiple" placeholder="请选择表头">
          <a-select-option v-for="el in columnsOptions" :key="el.dataIndex" :value="el.dataIndex">{{el.title}}</a-select-option>
        </a-select> -->
        <a-select v-model="constraintOptions" @change="updateConstraint">
          <a-select-option value="day">按日粮约束</a-select-option>
          <a-select-option value="supplementary">按补充料约束</a-select-option>
        </a-select>
        <a-badge>
          <a-tooltip>
            <template slot="title"> 新增 </template>
            <!-- <a-icon type="diff" @click="toggleRawVisible" style="font-size:16px;color: #1890ff;" /> -->
            <a-button type="link" @click="toggleRawVisible">
              <img :src="addImg" alt="新增" />
            </a-button>
          </a-tooltip>
        </a-badge>
        <a-badge :count="selectedRowKeys.length" @click="() => {
          selectedRowKeys.length && removeRaw();
        }
          " :style="{
            cursor: selectedRowKeys.length ? 'pointer' : 'not-allowed',
          }">
          <a-tooltip>
            <template slot="title"> 删除 </template>
            <!-- <a-icon type="delete" style="font-size:16px;" :style="{color: selectedRowKeys.length ? 'red' : '#ccc'}" /> -->
            <a-button type="link" :disabled="selectedRowKeys.length === 0">
              <img :src="deleteImg" alt="删除" />
            </a-button>
          </a-tooltip>
        </a-badge>
        <a-tooltip>
          <template slot="title">取整参数设置</template>
          <a-button type="link" @click="toggleRoundingSet">
            <img :src="rounding" alt="取整参数设置" />
          </a-button>
        </a-tooltip>
        <a-tooltip>
          <template slot="title"> 原料过滤 </template>
          <a-dropdown>
            <a-button type="link" @click="(e) => e.preventDefault()">
              <!-- <a-icon type="control" style="font-size: 16px;"/> -->
              <img :src="filterMaterial" alt="原料过滤" />
            </a-button>
            <a-menu slot="overlay">
              <a-menu-item>
                <span :style="{ color: rawsType === 'all' ? '#1890ff' : '' }"
                  @click="() => rawsChange('all')">所有原料</span>
              </a-menu-item>
              <a-menu-item>
                <span :style="{ color: rawsType === '1' ? '#1890ff' : '' }" @click="() => rawsChange('1')">组分原料</span>
              </a-menu-item>
              <a-menu-item>
                <span :style="{ color: rawsType === '2' ? '#1890ff' : '' }" @click="() => rawsChange('2')">拒绝原料</span>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </a-tooltip>
        <!-- <a-dropdown>
          <a class="ant-dropdown-link" @click="e => e.preventDefault()">
            <a-icon type="control" style="font-size: 16px;"/>
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a href="javascript:;" :style="{color: rawsType === 'all'?'#1890ff':''}" @click="() => rawsChange('all')">所有原料</a>
            </a-menu-item>
            <a-menu-item>
              <a href="javascript:;" :style="{color: rawsType === '1'?'#1890ff':''}" @click="() => rawsChange('1')">组分原料</a>
            </a-menu-item>
            <a-menu-item>
              <a href="javascript:;" :style="{color: rawsType === '2'?'#1890ff':''}" @click="() => rawsChange('2')">拒绝原料</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown> -->
        <!-- <a-dropdown v-model="dropdownVisible">
          <a class="ant-dropdown-link" @click="e => e.preventDefault()">
            <a-icon type="filter" style="font-size: 16px;"/>
          </a>
          <a-menu slot="overlay">
            <a-checkbox-group class="ell-label" :defaultValue="rawEditors2" @change="colChange" style="background: #fff;padding: 8px;">
              <div v-for='allItem in columnsOptions' :key="allItem.dataIndex" style="padding-bottom: 5px;">
                <a-checkbox :value="allItem.dataIndex">{{allItem.title}}</a-checkbox>
              </div>
            </a-checkbox-group>
          </a-menu>
        </a-dropdown> -->
        <a-dropdown>
          <a-tooltip placement="top">
            <a-dropdown v-model="dropdownVisible">
              <a-button type="link" @click="(e) => e.preventDefault()">
                <!-- <a-icon type="filter" style="font-size: 16px;"/> -->
                <img :src="filterConditions" />
              </a-button>
              <a-menu slot="overlay">
                <a-checkbox-group class="ell-label" :defaultValue="rawEditors2" @change="colChange"
                  style="background: #fff">
                  <div v-for="allItem in columnsOptions" :key="allItem.dataIndex" style="padding-bottom: 5px">
                    <a-checkbox :value="allItem.dataIndex">{{
                      allItem.title
                      }}</a-checkbox>
                  </div>
                </a-checkbox-group>
              </a-menu>
            </a-dropdown>
            <template slot="title"> 配方显示列 </template>
          </a-tooltip>
        </a-dropdown>
        <slot />
        <!-- </a-space> -->
      </div>
    </a-row>

    <!-- @change="listChange" -->
    <resize-table style="height: calc(100% - 50px)" tableName="RawEditor2ColumnsArr" :scroll="{
      x: 200,
      y: detail.referPriceSource
        ? leftBoxBottomHeight - 50
        : leftBoxBottomHeight,
    }" bordered :columns="rawEditor2Columns" :loading="rawListLoading" :data-source="list.records" :row-selection="{
      selectedRowKeys,
      onChange: onSelectChange,
      getCheckboxProps,
    }" :row-key="(record) => record.id" :pagination="false" :rowClassName="rowClassname">

      <div slot="customTitle" style="display:flex">
        <a-icon @click="fixedCol" type="pushpin" :theme="filled ? 'filled' : 'outlined'" />
        原料名称
      </div>

      <div slot="rawName" slot-scope="text, item" style="display: flex;">
        <!-- 失效图标 -->
        <template v-if="item.status === 1">
          <img style="width: 26px; position: absolute; top: 0; left: 0" src="@/assets/images/shixiao.svg" />
          <div style="width: 6px"></div>
        </template>
        <!-- <span class="storageTips" v-if="!item.storageWeight"><a-icon type="tags" /></span> -->
        <a-tooltip size="small">
          <a-row v-if="item.isRawDelete == 1" type="flex" align="middle" justify="space-between">
            <span style="flex: 1; padding: 4px 2px" class="nameStyle"
              :class="{ 'turnoverday-tip': turnoverDayTip(item) }">{{
              overseasFlag == "1" ? item.aliasName || text : text
              }}</span>
            <a-button v-if="item.isExtraProRaw != '1'" type="link" size="small" icon="delete" @click="viewRaw(item)" />
          </a-row>

          <a-row v-if="item.isRawDelete != 1 && item.isExtraProRaw == '1'" type="flex" align="middle"
            justify="space-between">
            <span style="flex: 1; padding: 4px 2px" class="nameStyle"
              :class="{ 'turnoverday-tip': turnoverDayTip(item) }">{{
              overseasFlag == "1" ? item.aliasName || text : text
              }}</span>
            <a-button type="link" size="small" icon="plus" @click="viewRaw(item)" />
          </a-row>

          <a v-if="item.isExtraProRaw != '1' && item.isRawDelete != 1" @click="viewRaw(item)" class="nameStyle"
            :class="{ 'turnoverday-tip': turnoverDayTip(item) }">{{
            overseasFlag == "1" ? item.aliasName || text : text }}
          </a>

          <template slot="title" placement="topLeft">
            {{ overseasFlag == "1" ? item.aliasName || text : text }}
            <span v-if="item.storageWeight || item.storageWeight === 0">
              ，库存【{{ Number(item.storageWeight).toFixed(3) }}{{ item.unit }}】
            </span>
            <span v-if="item.turnoverDay || item.turnoverDay === 0">
              ，可耗用天数【{{ item.turnoverDay }}天】
            </span>
          </template>
        </a-tooltip>

        <!-- 可耗用库存提示 -->
        <!-- <a-tooltip v-if="turnoverDayTip(item)" :overlayStyle="{ maxWidth: 'auto' }">
          <template slot="title">
            高库存原料（>{{ (item.purchaseClassCode === '1001' ? '15' : '30') }}天）：可耗用天数【{{ item.turnoverDay }}天】
          </template>
          <img style="width: 14px;height: 14px;position: relative;top: 2px;left: 4px;"
            src="../../../../assets/images/storageTip.png" />
        </a-tooltip> -->
      </div>

      <template slot="turnoverDay" slot-scope="text">
        <span>{{ text || text === 0 ? text.toFixed(2) : "" }}</span>
      </template>

      <span v-for="col in ['price', 'minValue', 'maxValue']" :slot="col" slot-scope="text, record" :key="col">
        <span :key="col" v-if="record.isRawDelete == 1 || record.isExtraProRaw == 1">{{ text ? text.toFixed(len(col)) :
          '' }}</span>
        <cell-editor v-else :isMix="true" :len="len(col)" :precision='len(col)' :item="record" :name="col"
          @blur="target => itemUpdate(target, record.id, col)" :text="text" :actions="e => update(e, col)"
          :background="record.isRawDelete != 1" :constraintOptions="constraintOptions" />
      </span>

      <span v-for="twin in [
        'storageWeight',
        'uasge',
        'maxShadowPrice',
        'minShadowPrice',
        'mixPercentage',
        'cost',
        'percentage',
        'minLimitValue',
        'maxLimitValue',
        'minApply',
        'maxApply',
      ]" :slot="twin" slot-scope="text" :key="twin">
        <span v-if="twin === 'cost'" :key="twin">{{
          text ? text.toFixed(len(twin)) : ""
          }}</span>
        <span v-else>{{
          text || text === 0 ? text.toFixed(len(twin)) : ""
          }}</span>
        <!-- {{text || text === 0 ? text.toFixed(len(twin)) : ''}} -->
      </span>
      <!-- <template
        slot="percentage"
        slot-scope="text"
      >
        {{ text || text === 0 ? Number(text).toFixed(3) : text}}
      </template> -->
      <template slot="weight" slot-scope="t, record">
        <!-- {{record.mixPercentage}}-{{detail.totalWeight}} -->
        {{
        (
        ((record.mixPercentage || 0) * (detail.totalWeight || 0)) /
        100
        ).toFixed(6)
        }}
      </template>

      <template slot="option" slot-scope="text, record">
        <a-space v-if="record.editable">
          <a-button type="primary" size="small" @click="() => saveHandle(record.id)" :loading="updateLoading"
            style="font-size: 12px">保存</a-button>
          <a-button size="small" style="font-size: 12px" @click="() => cancelHandle(record.id)">取消</a-button>
        </a-space>
        <span v-else class="save_class">
          <a-button size="small" type="link" @click="() => eidtorItem(record.id)">编辑</a-button>
        </span>
      </template>

      <template slot="productRawPercentage" slot-scope="text, record">
        {{
        text
        | numberFixed(
        record.unit === "MJ" || record.unit === "Kcal" ? 0 : 4
        )
        }}
      </template>

      <template slot="footer">
        <a-alert v-if="this.alertFlag && this.selectedRows.length > 0" type="info" show-icon closable
          @close="cancelOnly" class="inline-alert">
          <template #message>
            <a-row type="flex" justify="space-between">
              <a-col>
                <span>
                  选中<span style="color: green">{{ selectedRows.length }}</span>个原料，
                  <span class="alert-info">
                    成本合计<span style="color: green">{{ totalCost.toFixed(3) }}</span>(元/吨)，
                    用量(%)合计<span style="color: green">{{ totalPercentage.toFixed(3) }}%</span>。
                  </span>
                </span>
              </a-col>
              <a-col>
                <a @click="cancelSelection" style="margin-right: 20px;">取消选中</a>
              </a-col>
            </a-row>
          </template>
        </a-alert>
      </template>
    </resize-table>

    <raw-model2 :hidden="rawVisible" @cancel="toggleRawVisible" @ok="addRaw" />
    <nutrient-modal ref="nutrientModel2" />
    <!-- 其他组件内容 -->
    <RoundingSetModal v-if="formulaId" :formula-id="formulaId" :roundingVisible="roundingSetVisible" @close="toggleRoundingSet" />
    <!-- <calculation-result-modal @ok="confirmResult" /> -->
  </div>
</template>

<script>
// 用量（%）= 最大值和极上限时，最大值、极上限显示为红色；用量（%）= 最小值和极下限时，最小值、极下限显示为绿色
import { nhfMixins } from '../../untils';
// import CalculationResultModal from '../modal/CalculationResultModal2.vue'
import NutrientModal from '../modal/NutrientModal2.vue';
import RawModel2 from '../modal/RawModel2.vue';
// import RawSide from '../modal/RawSide.vue'
import CellEditor from './CellEditor.vue';
import rawEditor2Columns from './RawEditor2Columns';
import filterMaterial from '@/assets/images/icon/filterMaterial.png';
import filterConditions from '@/assets/images/icon/filterConditions.png';
import addImg from '@/assets/images/icon/add.png';
import deleteImg from '@/assets/images/icon/delete.png';
import rounding from '@/assets/images/icon/rounding.png';
import RoundingSetModal from "@/components/Nhf/Compound/modal/RoundingSetModal.vue";
export default {
  mixins: [nhfMixins],
  components: {
    RoundingSetModal,
    RawModel2,
    CellEditor,
    // CalculationResultModal,
    NutrientModal
  },
  data() {
    return {
      constraintOptions: 'day',
      filterMaterial, filterConditions, addImg, deleteImg, rounding, // icon
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      sss: rawEditor2Columns,
      rawsType: 'all',
      itemVisible: false,
      rawVisible: false,
      rawListLoading: false,
      filterData: {},
      currentValue: null,
      priceValues: '',
      rawValue: 0,
      list: {
        records: []
      },
      cacheData: [],
      rawTypes: [
        '所有原料', '组分原料', '拒绝原料'
      ],
      // 原料名称、代码、价格、用量%、最小值、最大值、用量(批次量)、影子价格下限、影子价格上限、单位成本、适用下限、适用上限、极下限、极上限；
      priceVal: ['privateContractPrice', 'privatePredictionPrice', 'privateStockPrice', 'privateMarketPrice'],
      columnsOptions: [
        {
          dataIndex: 'rawCode',
          title: '代码',
          sorter: (a, b) => a.rawCode - b.rawCode,
          sortDirections: ['descend', 'ascend'],
          width: 100
        },
        {
          dataIndex: 'price',
          scopedSlots: { customRender: 'price' },
          align: 'center',
          title: '价格',
          sorter: (a, b) => a.price - b.price,
          sortDirections: ['descend', 'ascend'],
          width: 100
        },
        {
          dataIndex: 'storageWeight',
          scopedSlots: { customRender: 'storageWeight' },
          align: 'center',
          title: '库存量',
          sorter: (a, b) => a.storageWeight - b.storageWeight,
          sortDirections: ['descend', 'ascend'],
          ellipsis: true,
          width: 100,
        },
        {
          dataIndex: 'turnoverDay',
          scopedSlots: { customRender: 'turnoverDay' },
          align: 'center',
          title: '可耗用(天)',
          sorter: (a, b) => a.turnoverDay - b.turnoverDay,
          sortDirections: ['descend', 'ascend'],
          ellipsis: true,
          width: 100,
        },
        {
          dataIndex: 'weight',
          align: 'center',
          title: '重量',
          scopedSlots: { customRender: 'weight' },
          sorter: (a, b) => a.mixPercentage - b.mixPercentage,
          sortDirections: ['descend', 'ascend'],
          width: 100
        },
        {
          dataIndex: 'mixPercentage',
          align: 'center',
          title: '用量(%)',
          scopedSlots: { customRender: 'mixPercentage' },
          sorter: (a, b) => a.mixPercentage - b.mixPercentage,
          sortDirections: ['descend', 'ascend'],
          width: 100
        },
        {
          dataIndex: 'percentage',
          align: 'center',
          title: '按补充料(%)',
          scopedSlots: { customRender: 'percentage' },
          sorter: (a, b) => a.percentage - b.percentage,
          sortDirections: ['descend', 'ascend'],
          width: 100
        },
        {
          dataIndex: 'productRawPercentage',
          align: 'center',
          title: '产品(%)',
          scopedSlots: { customRender: 'productRawPercentage' },
          sorter: (a, b) => a.productRawPercentage - b.productRawPercentage,
          sortDirections: ['descend', 'ascend'],
          width: 100
        },
        {
          dataIndex: 'uasge',
          align: 'center',
          title: '实际重量',
          scopedSlots: { customRender: 'uasge' },
          sorter: (a, b) => a.uasge - b.uasge,
          sortDirections: ['descend', 'ascend'],
          width: 100
        },
        {
          dataIndex: 'minValue',
          scopedSlots: { customRender: 'minValue' },
          align: 'center',
          title: '最小值',
          sorter: (a, b) => a.minValue - b.minValue,
          sortDirections: ['descend', 'ascend'],
          width: 100
        },
        {
          dataIndex: 'maxValue',
          scopedSlots: { customRender: 'maxValue' },
          align: 'center',
          title: '最大值',
          sorter: (a, b) => a.maxValue - b.maxValue,
          sortDirections: ['descend', 'ascend'],
          width: 100
        },
        {
          dataIndex: 'cost',
          align: 'center',
          title: '单位成本',
          scopedSlots: { customRender: 'cost' },
          sorter: (a, b) => a.cost - b.cost,
          sortDirections: ['descend', 'ascend'],
          width: 90
        },
        // {
        //   dataIndex:'uasge',
        //   title:'用量(批次量)',
        //   scopedSlots: {customRender: 'uasge'},
        //   width:this.layout.layoutType ? 100 : 130,
        //   align:'center'
        // },
        {
          dataIndex: 'minShadowPrice',
          align: 'center',
          title: '影子价格下限',
          scopedSlots: { customRender: 'minShadowPrice' },
          sorter: (a, b) => a.minShadowPrice - b.minShadowPrice,
          sortDirections: ['descend', 'ascend'],
          width: 120
        },
        {
          dataIndex: 'maxShadowPrice',
          align: 'center',
          title: '影子价格上限',
          scopedSlots: { customRender: 'maxShadowPrice' },
          sorter: (a, b) => a.maxShadowPrice - b.maxShadowPrice,
          sortDirections: ['descend', 'ascend'],
          width: 120
        },

        {
          dataIndex: 'minApply',
          align: 'center',
          title: '适用下限',
          scopedSlots: { customRender: 'minApply' },
          sorter: (a, b) => a.minApply - b.minApply,
          sortDirections: ['descend', 'ascend'],
          width: 100
        },
        {
          dataIndex: 'maxApply',
          align: 'center',
          title: '适用上限',
          scopedSlots: { customRender: 'maxApply' },
          sorter: (a, b) => a.maxApply - b.maxApply,
          sortDirections: ['descend', 'ascend'],
          width: 100
        },
        {
          dataIndex: 'minLimitValue',
          scopedSlots: { customRender: 'minLimitValue' },
          align: 'center',
          title: '极下限',
          sorter: (a, b) => a.minLimitValue - b.minLimitValue,
          sortDirections: ['descend', 'ascend'],
          width: 100
        },
        {
          dataIndex: 'maxLimitValue',
          scopedSlots: { customRender: 'maxLimitValue' },
          align: 'center',
          title: '极上限',
          sorter: (a, b) => a.maxLimitValue - b.maxLimitValue,
          sortDirections: ['descend', 'ascend'],
          width: 100
        },
      ],
      columnsArr: [],
      dropdownVisible: false,
      tableNum: 0,
      filled: true,
      roundingSetVisible: false, // 控制 RoundingSetModal 显示状态
      formulaId: null,
    };
  },
  mounted() {
    const { id } = this.$route.query;
    this.formulaId = id;
    let list = window.localStorage.getItem('RawEditor2');
    if (list && list !== 'null') {
      this.columnsArr = JSON.parse(list);
    }
    // else{
    //   let num = 0
    //   this.columnsOptions.forEach(el => {
    //     num += el.width
    //   })
    //   num += 200
    //   this.tableNum = num
    // }
  },
  props: {
    weightNum: {
      type: Number,
      default: 0
    }
  },
  computed: {
    // tableX(){
    //   let num = 0
    //   this.columns.forEach(el => {
    //     num += el.width
    //   })
    //   return Math.max(this.leftWidth - 30,num)
    // },
    // columns(){
    //   let options = this.columnsOptions.filter(el => this.columnsArr.includes(el.dataIndex))
    //   let first = {
    //     dataIndex:'rawName',
    //     fixed: this.leftWidth - 30 < this.tableNum ? 'left' : '',
    //     title: '名称',
    //     scopedSlots: {customRender: 'rawName'},
    //     sorter: (a, b) => a.rawName.localeCompare(b.rawName,'zh'),
    //     width: 200,
    //   }
    //   let lst = [first,...options]
    //   return lst
    // },
    leftSpan() {
      const { layout } = this.$store.state;
      const { showSider } = layout;
      return showSider ? 4 : 24;
    },
    rightSpan() {
      const { layout } = this.$store.state;
      const { showSider } = layout;
      return showSider ? 20 : 24;
    },
    removeDisable() {
      return this.selectedRowKeys.length === 0;
    },
    priceValue() {
      let pr = this.priceOption[this.detail.priceSource - 1];
      return pr ? pr.label : null;
    },
    listData() {
      let rawIds = this.selectedRowKeys.map(item => {
        return this.selectedRows.filter(i => i.id === item)[0].rawId;
      });
      return {
        // rawIds:this.selectedRows.map(item => item.id).join(),
        ids: this.selectedRowKeys.join(),
        rawIds: rawIds.join(),
        formulaId: this.formulaId
      };
    },
    selfProvidedProportion() {
      let { formulaExtMix } = this.detail || {};
      let { selfProvidedProportion } = formulaExtMix || {};
      return selfProvidedProportion || 0;
    },
  },

  watch: {
    detail() {
      let pr = this.priceOption[this.detail.priceSource - 1];
      this.priceValues = pr ? pr.label : null;
      let { formulaExtMix } = this.detail || {};
      let { constraintOptions } = formulaExtMix || {};
      this.constraintOptions = constraintOptions || 'day';
    },
    selectedRows(rawRows) {
      this.$emit('select', rawRows);
      this.setState({ rawSelect: rawRows[0], rawRows });
    },
    constraintOptions(val) {
      this.recalculateLimitation(val);
    },
  },

  methods: {
    async updateConstraint(constraintOptions) {
      let { formulaExtMix } = this.detail || {};
      let data = Object.assign({}, formulaExtMix, { constraintOptions });
      await this.fetchPost({
        actions: this.updateFormulaMixConstraintOptions,
        data,
        showMessage: false
      });
    },
    recalculateLimitation(type) {
      this.list.records.map(el => {
        if (el.minValue) el.minValue = this.calculateLimitation(el.minValue, type, true);
        if (el.maxValue) el.maxValue = this.calculateLimitation(el.maxValue, type, true);

        if (el.minLimitValue) el.minLimitValue = this.calculateLimitation(el.minLimitValue, type, true);
        if (el.maxLimitValue) el.maxLimitValue = this.calculateLimitation(el.maxLimitValue, type, true);
      });
    },
    calculateLimitation(val, type, flag) {
      let num = 0;
      if (val || val === 0) {
        if (type === 'day') {
          if (flag) num = (val * (100 - this.selfProvidedProportion) / 100).toFixed(6);
        } else {
          if (flag) num = (val / (100 - this.selfProvidedProportion) * 100).toFixed(6);
        }
      }
      return num;
    },
    len(col) {
      let len = 3;
      if (['minValue', 'maxValue', 'weight', 'mixPercentage', 'percentage', 'uasge'].includes(col)) len = 4;
      return len;
    },
    changeColumns() {
      let rawEditor2Columns = [...this.rawEditor2Columns];
      if (this.filled) {
        rawEditor2Columns[0].fixed = 'left';
      } else {
        delete rawEditor2Columns[0].fixed;
      }
      this.setState({ rawEditor2Columns });
    },
    fixedCol(e) {
      this.filled = !this.filled;
      this.changeColumns();
      e = e || window.event;
      if (e.stopPropagation) { //W3C阻止冒泡方法
        e.stopPropagation();
      } else {
        e.cancelBubble = true; //IE阻止冒泡方法
      }
    },
    colChange(val) {
      this.setState({ rawEditors2: val });
      window.localStorage.setItem('RawEditor2', JSON.stringify(val));
    },
    getCloumns(dataIndex) {
      if (this.columnsArr.includes(dataIndex)) {
        this.columnsArr = this.columnsArr.filter(el => el !== dataIndex);
      } else {
        this.columnsArr.push(dataIndex);
      }
    },
    rawsChange(val) {
      let newData = JSON.parse(JSON.stringify(this.cacheData));
      this.rawsType = val;
      window.localStorage.setItem('rawsType2', this.rawsType);
      if (this.rawsType === 'all') {
        this.list.records = newData;
      } else if (this.rawsType === '1') {
        this.list.records = newData.filter(v => v.uasge && v.uasge > 0);
      } else if (this.rawsType === '2') {
        this.list.records = newData.filter(v => !v.uasge);
      }
    },
    confirmResult(changeList, otherList) {
      this.$emit('ok', changeList, otherList);
    },

    getResult(rawResult) {
      this.rawResult = rawResult;
      this.toggleResultVisible();
    },
    viewRaw(rawSelect) {
      if (rawSelect.isRawDelete == 1) {
        this.$message.warn('原料已经删除');
        this.removeRaw(rawSelect);
      } else {
        if (rawSelect.isExtraProRaw == 1) {
          this.addRaw([rawSelect], true);
        } else {
          this.setState({ rawSelect, calculaVisible: true });
        }
        // this.setState({rawSelect})
        // this.toggleVisible('raw')

      }
      // this.setState({rawSelect,calculaVisible:true})
      // this.toggleVisible('raw2')
    },
    rowClassname(record) {
      // return record.percentage === 0 ? 'selectRows' : ''
      return record.isRawDelete === '1' || record.isExtraProRaw == 1 ? 'selectGary' : (record.percentage == 0 ? 'selectRows' : '');
    },
    getCheckboxProps(record) {
      return ({
        props: {
          disabled: record.isRawDelete == 1 || record.isExtraProRaw == 1,
        }
      });
    },

    cleanSelect() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },

    priceChange(value) {
      const currentItem = this.priceVal[value - 1];
      // const col = [...this.columns]
      // const colItem =  col.filter(i=>i.type === 'price')[0]
      // const index = this.columns.findIndex(i=>i.type === 'price')
      let val = 0;
      if (value && this.list.records.length) {
        this.list.records.forEach(prev => {
          val += prev.percentage * prev[currentItem];
        });
      }
      const priceValueAmount = (val / 100).toFixed(2);
      this.list.records = this.list.records.map(i => {
        i.price = i[currentItem];
        return i;
      });
      // colItem.dataIndex = this.priceVal[value - 1]
      // colItem.sorter = (a,b)=>a[this.priceVal[value - 1]]-b[this.priceVal[value - 1]]
      // this.columns.splice(index,1,colItem)
      this.$emit('prcieChange', val ? priceValueAmount : null);
    },

    addSignleRaw() {
      this.getList();
    },

    async addRaw(row, isSider) {
      this.rawListLoading = true;
      isSider || this.toggleRawVisible();
      await this.fetchPost({
        actions: this.saveFormulaRawIds,
        loading: 'addLoading',
        data: {
          rawIds: row.map(i => i.rawId).join(), // item.rawId,
          formulaId: this.$route.query.id,
          factoryId: this.factoryId
        }
      });
      this.getList();
    },

    toggleRawVisible() {
      this.rawVisible = !this.rawVisible;
    },

    itemChange(value, id, column) {
      const newData = [...this.list.records];
      const target = newData.filter(item => id === item.id)[0];
      if (target) {
        target[column] = value;
        this.list.records = newData;
      }
    },

    eidtorItem(id) {
      const newData = [...this.list.records];
      const target = newData.filter(item => id === item.id)[0];
      this.editingKey = id;
      if (target) {
        target.editable = true;
        this.list.records = newData;
      }
    },

    saveHandle(key) {
      const newData = [...this.list.records];
      const newCacheData = [...this.cacheData];
      const target = newData.filter(item => key === item.id)[0];
      const targetCache = newCacheData.filter(item => key === item.id)[0];
      if (target && targetCache) {
        delete target.editable;
        this.list.records = newData;
        Object.assign(targetCache, target);
        this.cacheData = newCacheData;
        this.update(target);
      }
    },

    itemUpdate(item, id) {
      const newData = [...this.list.records];
      const newCacheData = [...this.cacheData];
      const targets = newData.filter(item => id === item.id)[0];
      const targetCache = newCacheData.filter(item => id === item.id)[0];
      if (targets && targetCache) {
        Object.assign(targetCache, item);
        Object.assign(targets, item);
        this.cacheData = newCacheData;
        this.list.records = newData;
        this.calculatePrice(item);
      }
    },

    cancelHandle(id) {
      let newData = [...this.list.records];
      let target = newData.filter(item => id === item.id)[0];
      this.editingKey = '';
      if (target) {
        Object.assign(target, this.cacheData.filter(item => id === item.id)[0]);
        target.editable = false;
        this.list.records = newData;
      }
    },

    rawChange(val) {
      let copyList = [...this.cacheData];
      if (val == 0) this.rawValue = 0;
      const fileterList = [i => i, i => i.uasge > 0, i => i.uasge === 0];
      this.list.records = val > 0 ? copyList.filter(fileterList[val]) : this.getList({ ...this.currentPage });
      // 组分原料：原料用量＞0；
      // 拒绝用料：原料用量==0；
    },
    computerTotal(data){
      //计算selectedRows中percentage和price和
      this.totalCost = 0
      this.totalPercentage = 0
      if(this.selectedRows.length>0){
        this.selectedRows.forEach((item)=>{
          //如果item 和 data id 相等是同一条数据，将百分比较和价格覆盖
          if(item.rawId === data.rawId){
            item.percentage = data.percentage
            item.price = data.price
          }
          if(item.price && item.percentage){
            this.totalCost = this.totalCost + item.price * item.percentage
            this.totalPercentage = this.totalPercentage + item.percentage
          }
        })
        if(this.totalCost!==0) {
          this.totalCost = this.fixedNumber(this.totalCost / 100, 1000)
        }
        if(this.totalPercentage!==0) {
          this.totalPercentage = this.fixedNumber(this.totalPercentage, 1000)
        }
      }
    },
    async update(arg, feild) {
      // if(!loading) this.rawListLoading = true
      let data = JSON.parse(JSON.stringify(arg));
      delete data.rawName;
      const cacheData = JSON.parse(JSON.stringify(data));
      if (this.constraintOptions === 'supplementary') {
        // val * (100 - this.selfProvidedProportion) / 100
        // val / (100 - this.selfProvidedProportion) * 100
        console.log('minValue', data.minValue * (100 - this.selfProvidedProportion) / 100, 4);
        if (data.minValue) data.minValue = (data.minValue * (100 - this.selfProvidedProportion) / 100).toFixed(6);
        if (data.maxValue) data.maxValue = (data.maxValue * (100 - this.selfProvidedProportion) / 100).toFixed(6);

        if (data.minLimitValue) data.minLimitValue = (data.minLimitValue * (100 - this.selfProvidedProportion) / 100).toFixed(6);
        if (data.maxLimitValue) data.maxLimitValue = (data.maxLimitValue * (100 - this.selfProvidedProportion) / 100).toFixed(6);
      }
      await this.fetchPost({
        actions: this.formularawUpdate,
        data,
        showMessage: false
      });
      await this.fetchPost({
        actions: this.formularawUpdateCache,
        data: cacheData,
        showMessage: false
      });
      // this.rawListLoading = false
      //   this.getList({
      //     ...this.currentPage
      //   })
      data.updateType = '2';
      data.feild = feild;
      this.$emit('getRes', data);
      this.computerTotal(data);
      return {};
    },

    async resetRaw() {
      if (this.selectedRows.length) {
        this.$confirm({
          title: '提示',
          content: '确认将选中的原料恢复至默认值吗？',
          okText: '继续',
          cancelText: '取消',
          onOk: async () => {
            await this.fetchPost({
              actions: this.resetFormulaRawIds,
              data: this.listData
            });
            this.getList();
          },
          onCancel() { },
        });
      } else {
        this.$message.warn('请选择需要更新的原料');
      }
    },

    async removeRaw(item) {
      this.$confirm({
        title: '提示',
        content: '确认将选中的原料移出？',
        okText: '继续',
        cancelText: '取消',
        onOk: async () => this.removeRawAction(item),
        onCancel() { },
      });
    },

    async removeRawAction(item) {
      await this.fetchPost({
        actions: this.mixBlendRemove,
        // data:this.listData
        data: item ? { formulaId: this.formulaId, ids: item.id, rawIds: item.rawId } : this.listData
      });
      this.getList();
      this.$emit('getRes');
      this.$refs['allRawList'] && this.$refs['allRawList'].getList();
    },

    calculatePrice(raws) {
      let count = 0;
      // let productPrice = 0
      let referCount = 0;
      this.cacheData.forEach(el => {
        count += (el.price || 0) * (el.percentage || 0) / 100;
        referCount += (el.referPrice || 0) * (el.percentage || 0) / 100;
      });
      // this.detail.price = Number(count.toFixed(3))
      // console.log('calculatePrice',this.detail.formulaSolutionType)
      if (this.detail.formulaSolutionType !== 1) this.$emit('countPrice', { count: Number(count.toFixed(3)), index: 2, raws, referCount });
    },
    async getList(arg = {}, record) {
      if (record && record.updateType === '2') return;
      if (record && record.updateType === '1' && !this.list.records.find(el => el.rawCode === record.rawCode)) {
        return;
      }
      this.list.records = [];
      // this.rawsType = 'all'
      const res = await this.fetchGet({
        isList: true,
        loading: 'rawListLoading',
        name: 'list',
        actions: this.formulaRawNhfPage,
        data: {
          formulaId: this.formulaId,
          factoryId: this.factoryId,
          ...arg,
          size: 1000
        }
      });
      let { data } = res || {};
      let { records } = data || {};
      if (records) {
        this.cleanSelect();
        this.cacheData = JSON.parse(JSON.stringify(res.data.records));
        let rawsType = window.localStorage.getItem('rawsType2');
        if (rawsType) {
          this.rawsType = rawsType;
          this.rawsChange(rawsType);
        }
        await this.calculatePrice();
        if (this.ishandle || this.constraintOptions === 'supplementary') {
          this.recalculateLimitation(this.constraintOptions);
          this.setState({ ishandle: false, });
        }
      }
      return res;
    },

    async listChange(page) {
      await this.getList({ ...this.currentPage, ...this.tablePageChange(page), ...this.filterData });
      this.$nextTick(() => {
        if (this.rawValue > 0) {
          this.rawChange(this.rawValue);
        }
      });
    },
    cancelOnly() {
      this.totalPercentage = 0;
      this.totalCost = 0;
      this.alertFlag = false;
    },
    cancelSelection() {
      this.selectedRows = [];
      this.selectedRowKeys = [];
      this.totalPercentage = 0;
      this.totalCost = 0;
      this.alertFlag = false;
    },
    turnoverDayTip(record) {
      //purchaseClassCode 1001: 大料，其余为小料
      if ((record.purchaseClassCode === '1001' && record.turnoverDay > 15)
        || (record.purchaseClassCode !== '1001' && record.turnoverDay > 30)) {
        return true;
      }
    },
    toggleRoundingSet(){
      this.roundingSetVisible = !this.roundingSetVisible;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ant-table.ant-table-bordered .ant-table-footer {
  padding: 0;
}
</style>

<style lang="scss">
.turnoverday-tip {
  color: #f87208;
}

.nameStyle {
  max-width: 130px;
}

h3 {
  margin: 0;
}

.red {
  color: red;
}

.green {
  color: green;
}

.selectRows {
  background-color: rgba(255, 206, 163, 0.1) !important;
  background-color: #fff9e5 !important;
}

.selectGary {
  background-color: rgba(130, 130, 130, 0.1) !important;
}
</style>
